import { render } from "./WheelSize.vue?vue&type=template&id=ebd283fa&scoped=true"
import script from "./WheelSize.vue?vue&type=script&lang=js"
export * from "./WheelSize.vue?vue&type=script&lang=js"

import "./WheelSize.vue?vue&type=style&index=0&id=ebd283fa&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebd283fa"]])

export default __exports__